import React from "react";
import PropTypes from "prop-types";

import Gallery from "@browniebroke/gatsby-image-gallery";
function basename(path) {
  return path.split("/").reverse()[0];
}
export default function DisplayGallery(props) {
  let {
    gallery, // `gallery` is an array of objects with `thumb` and `full`
    divClass = "gallery-outer",
    colWidth,
    imgClass,
    sort,
  } = props;

  let images = [];

  if (gallery && gallery.length) {
    images = gallery.map((element) => element.image.childImageSharp);
  } else if (gallery && gallery.length) {
    images = gallery;
  }
  let unsorted = [],
    image;

  if (images.length) {
    if (sort) {
      // build object using filename as keys
      images.forEach((image) => {
        unsorted[basename(image.full.images.fallback.src)] = image;
      });
      //sort the object
      const sorted = Object.keys(unsorted)
        .sort()
        .reduce((obj, key) => {
          obj[key] = unsorted[key];
          return obj;
        }, {});
      // rebuild the array
      images = [];
      for (image in sorted) {
        images.push(sorted[image]);
      }
    }
    //console.log(images);
    return (
      <div className={divClass}>
        <Gallery images={images} colWidth={colWidth} imgclassName={imgClass} />
      </div>
    );
  } else {
    return null;
  }
}

DisplayGallery.propTypes = {
  gallery: PropTypes.array,
};
